import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { UserDomain, UserDomainRecordCreate } from '../../synaps-media.types';
import * as DomainsActions from './domains.actions';
import * as DomainsSelectors from './domains.selectors';
import { DomainsState } from './domains.state';

@Injectable({
  providedIn: 'root'
})
export class DomainsFacade {
  domains$ = this.store.select(DomainsSelectors.selectAllDomains);
  activeDomains$ = this.store.select(DomainsSelectors.selectActiveDomains);
  waitingConfigurationDomains$ = this.store.select(DomainsSelectors.selectWaitingConfigurationDomains);
  managedDomains$ = this.store.select(DomainsSelectors.selectManagedDomains);
  loading$ = this.store.select(DomainsSelectors.selectDomainsLoading);
  loadingCreate$ = this.store.select(DomainsSelectors.selectDomainsCreating);
  error$ = this.store.select(DomainsSelectors.selectDomainsError);
  selectedDomain$ = this.store.select(DomainsSelectors.selectSelectedDomain);

  constructor(private store: Store<DomainsState>) {}

  loadDomains(): void {
    this.store.dispatch(DomainsActions.loadDomains());
  }

  loadDomain(domain: string): void {
    this.store.dispatch(DomainsActions.loadDomain({ domain }));
  }

  addDomainRecord(domain: string, record: Partial<UserDomainRecordCreate>): void {
    this.store.dispatch(DomainsActions.addDomainRecord({ domain, record }));
  }

  updateDomainRecord(domain: string, recordId: number, record: Partial<UserDomainRecordCreate>): void {
    this.store.dispatch(DomainsActions.updateDomainRecord({ domain, recordId, record }));
  }

  deleteDomainRecord(domain: string, recordId: number): void {
    this.store.dispatch(DomainsActions.deleteDomainRecord({ domain, recordId }));
  }

  selectDomain(domainId: number): void {
    this.store.dispatch(DomainsActions.selectDomain({ domainId }));
  }

  getDomainByName(domainName: string): Observable<UserDomain | null> {
    return this.store.select(DomainsSelectors.selectDomainByName(domainName));
  }
}
